// import React from 'react'
import React, { useEffect, useState } from 'react'
import axios from '../../API/axios';
import { Link } from 'react-router-dom';
import moment from 'moment';
import error from "../../assets/images/Not-Found.png";

const RecruiterProfile = () => {
    const userUID = localStorage.getItem('userUID')

    const [loading, setLoading] = useState(true)
    const [isError, setIsError] = useState(false);
    const [profileData, setProfileData] = useState('')
    const GetProfile = async () => {
        setLoading(true)
        try {
            const res = await axios.get(`/Company/GetProfile?UID=${userUID}&CompType=Recruiter`);
            setProfileData(res.data.responseData)
            console.log("resss", res);
            setLoading(false)
        }
        catch (error) {
            console.log('error', error);
            setIsError(true);
        }
    };
    useEffect(() => {
        GetProfile()
    }, [])

    return (
        <>
            {loading ? (
                <div className="mt-6 d-flex justify-content-center">
                    <p>Loading...</p>
                </div>
            ) : isError ? (
                <div className="mt-6 d-flex justify-content-center">
                    <img src={error} alt="404 Not Found" width={300} />
                </div>
            ) : (
                <div className="profile-resume-main-container pt-3">

                    <div className="profile-resume-heading-cont d-flex align-items-center p-4">
                        <div className="profile-resume-empty-cont me-2"></div>
                        <h2>Profile</h2>
                    </div>

                    <div className="profile-resume-userinfo mb-3">
                        <div className="row pt-4 pb-4 align-center">
                            <div className="col-lg-2 col-md-3">
                                <div className="profile-resume-image d-flex justify-content-center">
                                    <img src={profileData.logoImage} alt="" srcset="" width={"100px"} style={{ borderRadius: "50%", height: "100px" }} />
                                </div>
                            </div>
                            <div className="col-lg-9 col-md-8">
                                {profileData.tagline === null ? '' : (
                                    <div className="profile-resume-designation f-14 f-600">
                                        {profileData.tagline}
                                    </div>
                                )}
                                <div className="d-flex align-items-center mb-1 Main-resume-username">
                                    <div className="profile-resume-username me-2">
                                        {profileData.name}
                                    </div>
                                </div>
                                <div className="d-flex Resume-Skills-Country-Mobile">

                                    <div className="profile-resume-country d-flex align-items-center">
                                        {profileData.cityName === null ? '' : (

                                            <div className="profile-resume-country-icon d-flex  align-item-center me-3 f-18  f-400">
                                                <span class="icon-map-pin me-2"></span>
                                                {profileData.cityName}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-4">


                            <div className="cv-form-details po-sticky job-sg single-stick email-cv-form-details profile-resume-userinfo ">
                                <ul className="list-infor email-list-infor p-0 mb-0">

                                    {/* {profileData.email === null ? "" : ( */}
                                    <li className='only-for-email mb-0 pb-0'>
                                        <div className="category Notification-Text">Email</div>
                                        <div className="detail">
                                            {/* {profileData.email || "N.A."} */}
                                            <a href={`mailto:${profileData.email}`}
                                                onClick={(e) => {
                                                    if (!profileData.email) {
                                                        e.preventDefault();
                                                        alert("Email is not available!");
                                                    }
                                                }}
                                            >
                                                {profileData.email || "N.A"}
                                            </a>
                                        </div>
                                    </li>
                                    {/* )} */}

                                    {/* {profileData.contactNo === null ? "" : ( */}
                                    <li className="only-for-email mb-0 pb-0">
                                        <div className="category Notification-Text"> Phone Number
                                        </div>
                                        <div className="detail">
                                            {/* {profileData.contactNo || "N.A."} */}
                                            <a href={`tel:${profileData.contactNo}`}
                                                onClick={(e) => {
                                                    if (!profileData.contactNo) {
                                                        e.preventDefault();
                                                        alert("Email is not available!");
                                                    }
                                                }}
                                            >
                                                {profileData.contactNo || "N.A"}
                                            </a>
                                        </div>
                                    </li>
                                    {/* )} */}

                                    {/* {profileData.website === null ? "" : ( */}
                                    <li className="only-for-email mb-0 pb-0">
                                        <div className="category Notification-Text">Website</div>
                                        <div className="detail">
                                            {/* {profileData.website || "N.A."} */}
                                            <a
                                                href={profileData.website ? profileData.website.startsWith("http") ? profileData.website : `https://${profileData.website}` : "#"}
                                                onClick={(e) => {
                                                    if (!profileData.website) {
                                                        e.preventDefault();
                                                        alert("Website is not available!");
                                                    }
                                                }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {profileData.website || "N.A."}
                                            </a>
                                        </div>
                                    </li>
                                    {/* )} */}

                                    {/* {profileData.companySize === null ? "" : ( */}
                                    <li className="only-for-email mb-0 pb-0">
                                        <div className="category Notification-Text">Company Size</div>
                                        <div className="detail">{profileData.companySize || "N.A."}</div>
                                    </li>
                                    {/* )} */}

                                    {/* {profileData.companyCategory === null ? "" : ( */}
                                    <li className="only-for-email mb-0 pb-0">
                                        <div className="category Notification-Text Company-cont">Company Category</div>
                                        <div className="detail Company-cont-details">{profileData.companyCategory || "N.A."}</div>
                                    </li>
                                    {/* )} */}

                                    {/* {profileData.industry === null ? "" : ( */}
                                    <li className="only-for-email mb-0 pb-0">
                                        <div className="category Notification-Text">Industry</div>
                                        <div className="detail">{profileData.industry || "N.A."}</div>
                                    </li>
                                    {/* )} */}

                                    {/* {profileData.startedDate === null ? "" : ( */}
                                    <li className="only-for-email mb-0 pb-0">
                                        <div className="category Notification-Text">Incorporate Date</div>
                                        <div className="detail">{moment(profileData.startedDate).format("DD MMM YYYY") || "N.A."}</div>

                                    </li>
                                    {/* )} */}

                                    {/* {profileData.address === null ? "" : ( */}
                                    <li className="only-for-email mb-0 pb-0">
                                        <div className="category Notification-Text">Address</div>
                                        <div className="detail">{profileData.address || "N.A."}</div>
                                    </li>
                                    {/* )} */}
                                </ul>
                            </div>
                        </div>

                        {profileData.about === null ? (
                            ""
                        ) : (
                            <>

                                <div className="col-lg-8 Aboutme-Container-Profile">
                                    <div className="profile-resume-parent-cont p-4 rounded-3">
                                        {profileData.about === null ? "" : (
                                            <div className="profile-resume-about">
                                                <div className="profile-resume-about-heading f-20 f-800 mb-1">
                                                    About
                                                </div>

                                                <div className="profile-resume-about-info">
                                                    {profileData.about ? (
                                                        <p className="f-14 f-400">{profileData.about}</p>
                                                    ) : null}
                                                </div>
                                            </div>
                                        )}

                                        {profileData.description === null ? "" :
                                            (
                                                <div className="profile-resume-education">
                                                    <div className="profile-resume-about-heading f-20 f-800 mb-1">
                                                        Description
                                                    </div>
                                                    {/* <div className="d-flex"> */}
                                                    <div className="profile-resume-verticle-line me-4"></div>
                                                    <div>
                                                        <div className="profile-resume-education-details mb-3">
                                                            <div className="profile-resume-education-designation-info f-14 f-400">
                                                                {profileData.description}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* </div> */}
                                                </div>
                                            )}
                                    </div>

                                </div>
                            </>
                        )}
                    </div>


                </div>
            )}</>
    )
}

export default RecruiterProfile